import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const QUESTION_SPRINT_MODE: ModeDescription = {
  mode: GameMode.QUESTION_SPRINT,
  title: 'Question Sprint',
  description: 'Answer multiple per question and move on when you are ready.',
  icon: '🚀',
};
